import * as benchlingUtil from 'BenchlingUtil';
import {ElementMouseEvent} from 'util/Types';

function isRightClick(e: MouseEvent): boolean {
  return e.which === 3 || e.ctrlKey;
}

function isMiddleClick(e: MouseEvent | ElementMouseEvent): boolean {
  return e.button === 1;
}

const MouseWheelEvent = benchlingUtil.firefox ? 'DOMMouseScroll' : 'mousewheel';

export {isRightClick, isMiddleClick, MouseWheelEvent};
